import React from 'react'
import { Row, Col, Button, Icon } from 'antd'
import styles from './style.module.scss'

const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.inner}>
      <Row type="flex" justify="space-between" gutter={[60, 30]}>
        <Col md={12} xs={24}>
          <ul>
            <li>
              <a
                href="https://www.forwardme.com/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://www.forwardme.com/terms/" target="_blank" rel="noopener noreferrer">
                Terms and Conditions
              </a>
            </li>
          </ul>
        </Col>
        <Col md={12} xs={24}>
          <ul className={styles.social}>
            <li>
              <a
                href="https://www.instagram.com/forwardme/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon type="instagram" style={{ fontSize: '18px' }} />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/forwardmeUS" target="_blank" rel="noopener noreferrer">
                <Icon type="twitter" style={{ fontSize: '18px' }} />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UC26vyrMwT-CeP5yXR2h7egw"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon type="youtube" style={{ fontSize: '18px' }} />
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/forwardmeUS/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon type="facebook" style={{ fontSize: '18px' }} />
              </a>
            </li>
            <li>
              <a href="https://www.forwardme.com/help" target="_blank" rel="noopener noreferrer">
                <Button>Help Center</Button>
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  </div>
)

export default Footer
